import { render } from "./BaseLoader.vue?vue&type=template&id=2c037c0c&scoped=true"
const script = {}

import "./BaseLoader.vue?vue&type=style&index=0&id=2c037c0c&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c037c0c"]])

export default __exports__